function initTrustedPartnersSwiper(sectionId) {
  var el = document.getElementById('tp-swiper-' + sectionId);
  if (!el || typeof Swiper === 'undefined') return;

  var gap = parseInt(el.dataset.gap) || 48;
  var loop = el.dataset.loop === 'true';
  var autoplay = el.dataset.autoplay === 'true';
  var autoplaySpeed = parseInt(el.dataset.autoplaySpeed) || 3000;

  new Swiper(el, {
    slidesPerView: 2,
    spaceBetween: gap,
    loop: loop,
    grabCursor: true,
    autoplay: autoplay
      ? {
          delay: autoplaySpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      : false,
    breakpoints: {
      480: { slidesPerView: 3, spaceBetween: 24 },
      550: { slidesPerView: 4, spaceBetween: gap },
      990: { slidesPerView: 6, spaceBetween: gap }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-section-id]').forEach(function (el) {
    if (el.classList.contains('trusted-partners__swiper')) {
      initTrustedPartnersSwiper(el.dataset.sectionId);
    }
  });
});

document.addEventListener('shopify:section:load', function (e) {
  initTrustedPartnersSwiper(e.detail.sectionId);
});